import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background" data-testid="loading-screen">
        <div className="text-center">
          <div className="inline-block w-12 h-12 border-2 border-border border-t-gold rounded-full animate-spin" />
          <p className="mt-4 text-sm text-ash font-sans">Loading…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated && !location.state?.user) {
    return <Navigate to="/welcome" state={redirectState} replace />;
  }

  return children;
};
